
import React from 'react';

interface UseMobileNavigationItemHandlersProps {
  onNavigationClick?: (href: string) => void;
  onClose: () => void;
}

export const useMobileNavigationItemHandlers = ({
  onNavigationClick,
  onClose
}: UseMobileNavigationItemHandlersProps) => {
  const handleClick = (href: string, e: React.MouseEvent) => {
    if (onNavigationClick) {
      e.preventDefault();
      onNavigationClick(href);
    }
    onClose();
  };

  return { handleClick };
};
